import { Card } from "@/src/components";
import { useBalances } from "@/src/hooks/useBalances";
import { fmt } from "@/src/lib/utils";

export const Tvl = () => {
  const { stakeBalance, crbPrice } = useBalances();
  return (
    <Card>
      <div className="space-y-1 mb-4">
        <h2 className="text-sm font-medium text-muted-foreground uppercase tracking-wider">Token Value</h2>
      </div>
      <div className="space-y-0 divide-y divide-border/50">
        <div className="flex items-center justify-between py-2.5">
          <span className="text-sm text-muted-foreground">FRB Price</span>
          <p className="text-lg sm:text-2xl font-bold text-foreground font-mono">
            {fmt(crbPrice, 6)} <span className="text-muted-foreground text-lg">$</span>
          </p>
        </div>
        <div className="flex items-center justify-between py-2.5">
          <span className="text-sm text-muted-foreground">Staked Value</span>
          <p className="text-lg sm:text-2xl font-bold text-foreground font-mono">
            {fmt(stakeBalance*crbPrice)} <span className="text-muted-foreground text-lg">$</span>
          </p>
        </div>
      </div>
    </Card>

  );
};
